const heroConfig = {
	color: {
		sg: "black--02",
		gn: "white",
		gp: "gradient",
		om: "white",
		la: "4",
		pm: "4",
	},
};

export default heroConfig;
